/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { FontWeights, IStackItemStyles, ITextStyles } from "@fluentui/react";

export const flexColumnStackStyles: IStackItemStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
  },
};

export const tfaTitleStyles: ITextStyles = {
  root: {
    fontWeight: FontWeights.semibold,
    fontSize: "1rem",
    margin: "0.125rem 0",
  },
};

export const tfaTextStyles: ITextStyles = {
  root: {
    margin: "0.125rem 0",
  },
};
